import PropTypes from 'prop-types';

import './ProcessFlow.css';

export function ProcessFlow({ steps, title = 'Our Approach' }) {
  // Basic validation
  if (!steps || steps.length === 0) {
    return null; // Don't render anything if no steps are provided
  }

  return (
    <div className="process-flow-section">
      <h3>{title}</h3>
      <div className="process-steps">
        {steps.map((step, index) => (
          <div className="process-step" key={index}>
            <div className="step-number">{index + 1}</div>
            <div className="step-content">
              <h4>{step.title}</h4>
              <p>{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

ProcessFlow.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
  title: PropTypes.string,
};
